const isHttps = window.location.protocol === 'https:';

export const WS_CONFIG = {
    PROTOCOL: isHttps ? 'wss:' : 'ws:',
    HOSTNAME: window.location.hostname,
    PORT: window.location.port === '80' || window.location.port === '' ? '' : `:${window.location.port}`,
    API_URL: '/api/ws/connection',
};

export const WS_FULL_URL = `${WS_CONFIG.PROTOCOL}//${WS_CONFIG.HOSTNAME}${WS_CONFIG.PORT}${WS_CONFIG.API_URL}`;
